// extracted by mini-css-extract-plugin
export var checkbox = "_9k-0";
export var circle = "_9k-3";
export var horizontalContainer = "_9k-7";
export var sm = "_9k-5";
export var switch0 = "_9k-2";
export var switchDisabled = "_9k-8";
export var switchEnabled = "_9k-1";
export var textSwitchContainer = "_9k-9";
export var textSwitchOption = "_9k-a";
export var textSwitchOptionSelected = "_9k-b";
export var verticalContainer = "_9k-6";
export var xs = "_9k-4";